exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\r\n/*@import \"~vue2-editor/dist/vue2-editor.css\";\r\n\r\n@import '~quill/dist/quill.core.css';\r\n@import '~quill/dist/quill.bubble.css';\r\n@import '~quill/dist/quill.snow.css';*/\r\n", ""]);

// exports
